
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Link from 'components/Link'
import Limit from 'containers/Limit'

export default class TopPanelMenu extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        to: PropTypes.string,
        title: PropTypes.string,
        onlyActiveOnIndex: PropTypes.bool
      })
    )
  }

  render() {
    return (
      <nav className='top-panel-menu'>
        {this.renderItems()}
      </nav>
    )
  }

  renderItems() {
    const {items, children} = this.props

    if (items) {
      return items.map(this.renderItem)
    } else {
      return children
    }
  }

  renderItem = (menuItem, index) => {
    if (!menuItem) return null

    const {
      to,
      onlyActiveOnIndex,
      limitKey,
      limitType
    } = menuItem

    return (
      <Link
        to={to}
        className='top-panel-menu_item'
        onlyActiveOnIndex={onlyActiveOnIndex}
        key={index}
      >
        <Limit
          limitKey={limitKey}
          type={limitType}
        >
          {menuItem.title}
        </Limit>
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/TopPanelMenu/index.js